import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef, useState, useEffect } from 'react';
import { useTheme } from '@swift-paypal/pp-react-theme';
import { SelectionMenu } from '@swift-paypal/pp-react-selection-menu';
import clsx from 'clsx';
import { V2CriticalIcon, CriticalAltIcon, ChevronUpAltIcon, ChevronDownAltIcon, V2ChevronUpIcon, V2ChevronDownIcon } from '@swift-paypal/pp-react-icons';
import '../__generated__/styles/dropdown-menu.css';

var styles = {"ppvx_dropdown-menu":"ppvx_dropdown-menu___1-7-0","ppvx_dropdown-menu__label":"ppvx_dropdown-menu__label___1-7-0","ppvx_dropdown-menu__button":"ppvx_dropdown-menu__button___1-7-0","ppvx_dropdown-menu__affordance-icon":"ppvx_dropdown-menu__affordance-icon___1-7-0","ppvx_dropdown-menu__label--empty":"ppvx_dropdown-menu__label--empty___1-7-0","ppvx_dropdown-menu__button--active":"ppvx_dropdown-menu__button--active___1-7-0","ppvx_dropdown-menu__helper-text":"ppvx_dropdown-menu__helper-text___1-7-0","ppvx_dropdown-menu__error-text":"ppvx_dropdown-menu__error-text___1-7-0","ppvx_dropdown-menu__error-icon":"ppvx_dropdown-menu__error-icon___1-7-0","ppvx_field--error":"ppvx_field--error___1-7-0","ppvx_dropdown-menu--combine-right":"ppvx_dropdown-menu--combine-right___1-7-0","ppvx_dropdown-menu--combine-left":"ppvx_dropdown-menu--combine-left___1-7-0","ppvx_dropdown-menu--combine-both":"ppvx_dropdown-menu--combine-both___1-7-0","ppvx_dropdown-menu__button-with-svg-icon":"ppvx_dropdown-menu__button-with-svg-icon___1-7-0","ppvx_dropdown-menu__error-text-with-svg-icon":"ppvx_dropdown-menu__error-text-with-svg-icon___1-7-0","ppvx--v2":"ppvx--v2___1-7-0","ppvx--v1":"ppvx--v1___1-7-0"};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getRefCurrent = function (ref) {
  return (
    /* istanbul ignore next */
    ref && ref.current ? ref.current : null
  );
}; // Get either the error message or helper text or... nothing


var renderMessage = function (errorText, helperText, msgId, theme) {
  if (errorText) {
    var dropdownErrorIcon = theme === 'v2' ? /*#__PURE__*/React.createElement(V2CriticalIcon, {
      className: styles['ppvx_dropdown-menu__error-icon'],
      size: "sm"
    }) : /*#__PURE__*/React.createElement(CriticalAltIcon, {
      className: styles['ppvx_dropdown-menu__error-icon'],
      size: "xs"
    });
    var errorClasses = clsx(styles['ppvx_dropdown-menu__error-text'], styles['ppvx_dropdown-menu__error-text-with-svg-icon']);
    return /*#__PURE__*/React.createElement("div", {
      className: errorClasses,
      id: msgId
    }, dropdownErrorIcon, errorText);
  }

  if (helperText) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['ppvx_dropdown-menu__helper-text'],
      id: msgId
    }, helperText);
  }

  return null;
}; // eslint-disable-next-line complexity


var DropdownMenu = function (_ref) {
  var _clsx;

  var className = _ref.className,
      menuContainerClassName = _ref.menuContainerClassName,
      menuListClassName = _ref.menuListClassName,
      menuItemClassName = _ref.menuItemClassName,
      menuMobileHeaderClassName = _ref.menuMobileHeaderClassName,
      menuButtonClassName = _ref.menuButtonClassName,
      menuLabelClassName = _ref.menuLabelClassName,
      _ref$skipButtonFocus = _ref.skipButtonFocus,
      skipButtonFocus = _ref$skipButtonFocus === void 0 ? false : _ref$skipButtonFocus,
      sheetClassName = _ref.sheetClassName,
      sheetWrapperClassName = _ref.sheetWrapperClassName,
      id = _ref.id,
      label = _ref.label,
      errorText = _ref.errorText,
      helperText = _ref.helperText,
      selectedItemIndex = _ref.selectedItemIndex,
      options = _ref.options,
      ariaLabelledby = _ref.ariaLabelledby,
      removeBorderRadiusRight = _ref.removeBorderRadiusRight,
      removeBorderRadiusLeft = _ref.removeBorderRadiusLeft,
      removeBorderRadiusBoth = _ref.removeBorderRadiusBoth,
      renderButtonContent = _ref.renderButtonContent,
      onSelection = _ref.onSelection,
      onClose = _ref.onClose,
      theme = _ref.theme,
      isLoadingOptions = _ref.isLoadingOptions,
      rest = _objectWithoutProperties(_ref, ["className", "menuContainerClassName", "menuListClassName", "menuItemClassName", "menuMobileHeaderClassName", "menuButtonClassName", "menuLabelClassName", "skipButtonFocus", "sheetClassName", "sheetWrapperClassName", "id", "label", "errorText", "helperText", "selectedItemIndex", "options", "ariaLabelledby", "removeBorderRadiusRight", "removeBorderRadiusLeft", "removeBorderRadiusBoth", "renderButtonContent", "onSelection", "onClose", "theme", "isLoadingOptions"]);

  var _theme = useTheme('DropdownMenu', theme);

  var isThemeV2 = _theme && _theme === 'v2';
  var buttonId = id ? "dropdownMenuButton_".concat(id) : "dropdownMenuButton_".concat(label.replace(/\s/g, ''));
  var buttonRef = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showMenu = _useState2[0],
      setShowMenu = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      initialItemFocus = _useState4[0],
      setKeyboardActive = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isRtl = _useState6[0],
      setRtl = _useState6[1];

  useEffect(function () {
    var btn = getRefCurrent(buttonRef);
    var computedStyle = window && window.getComputedStyle(btn);
    setRtl(computedStyle && computedStyle.direction === 'rtl');
  });
  var dropdownMenuClass = clsx(styles['ppvx_dropdown-menu'], (_clsx = {}, _defineProperty(_clsx, styles['ppvx--v2'], isThemeV2), _defineProperty(_clsx, styles['ppvx_field--error'], errorText), _defineProperty(_clsx, styles['ppvx_dropdown-menu--combine-right'], removeBorderRadiusRight), _defineProperty(_clsx, styles['ppvx_dropdown-menu--combine-left'], removeBorderRadiusLeft), _defineProperty(_clsx, styles['ppvx_dropdown-menu--combine-both'], removeBorderRadiusBoth), _clsx), className);
  var buttonClass = clsx(styles['ppvx_dropdown-menu__button'], styles['ppvx_dropdown-menu__button-with-svg-icon'], showMenu && styles['ppvx_dropdown-menu__button--active'], menuButtonClassName);
  var msgId = helperText && 'dropdown_helperText' || errorText && 'dropdown_errorText';
  var buttonText;

  if (selectedItemIndex >= 0 && selectedItemIndex < options.length) {
    if (renderButtonContent) {
      buttonText = renderButtonContent();
    } else {
      buttonText = options[selectedItemIndex].primaryText;
    }
  } else {
    buttonText = '';
  }

  var ariaLabelAttr = !buttonText && {
    'aria-label': label
  };

  var otherButtonAttr = _objectSpread(_objectSpread(_objectSpread({}, msgId && {
    'aria-describedby': msgId
  }), ariaLabelAttr), rest);

  var V1AffordanceIcon = showMenu ? ChevronUpAltIcon : ChevronDownAltIcon;
  var V2AffordanceIcon = showMenu ? V2ChevronUpIcon : V2ChevronDownIcon;
  var affordanceClass = styles['ppvx_dropdown-menu__affordance-icon'];
  var AffordanceIcon = isThemeV2 ? /*#__PURE__*/React.createElement(V2AffordanceIcon, {
    size: "sm",
    className: affordanceClass
  }) : /*#__PURE__*/React.createElement(V1AffordanceIcon, {
    size: "xs",
    className: affordanceClass
  });
  var labelClasses = clsx(styles['ppvx_dropdown-menu__label'], !buttonText && styles['ppvx_dropdown-menu__label--empty'], menuLabelClassName);
  var labelledBy = ariaLabelledby ? "".concat(buttonId, "-label ").concat(ariaLabelledby) : "".concat(buttonId, "-label");
  return /*#__PURE__*/React.createElement("div", {
    className: dropdownMenuClass,
    id: id
  }, /*#__PURE__*/React.createElement("button", _extends({
    className: buttonClass,
    type: "button",
    id: buttonId,
    ref: buttonRef,
    "aria-haspopup": "listbox",
    "aria-expanded": showMenu,
    "aria-labelledby": labelledBy,
    onClick: function openMenu(evt) {
      setShowMenu(function (prevState) {
        return !prevState;
      });
      setKeyboardActive(!evt.detail);
    }
  }, otherButtonAttr), AffordanceIcon, buttonText), /*#__PURE__*/React.createElement("label", {
    id: "".concat(buttonId, "-label"),
    htmlFor: buttonId,
    className: labelClasses
  }, label), /*#__PURE__*/React.createElement(SelectionMenu, {
    initialItemFocus: initialItemFocus,
    isOpen: showMenu,
    mobileTitle: label,
    onClose: function handleClose(evt) {
      setShowMenu(false);

      if (onClose) {
        onClose(evt);
      }
    },
    onSelection: function handleItemClick(index) {
      setShowMenu(false);
      var buttonCurrent = getRefCurrent(buttonRef);
      /* istanbul ignore next */

      if (buttonCurrent) {
        if (skipButtonFocus) {
          buttonCurrent.blur();
        } else {
          buttonCurrent.focus();
        }
      }
      /* istanbul ignore else */


      if (onSelection) {
        onSelection(index);
      }
    },
    selectedIndex: selectedItemIndex,
    triggerElementId: buttonId,
    options: options,
    className: menuListClassName,
    containerClassName: menuContainerClassName,
    itemClassName: menuItemClassName,
    mobileHeaderClassName: menuMobileHeaderClassName,
    sheetClassName: sheetClassName,
    sheetWrapperClassName: sheetWrapperClassName,
    rtl: isRtl,
    returnFocusToTrigger: !skipButtonFocus,
    theme: _theme,
    isLoadingOptions: isLoadingOptions
  }), renderMessage(errorText, helperText, msgId, _theme));
};

export { DropdownMenu };
